// DelegatedAgentsContext: what the Agents list, the rail's Agents pill and the
// inline sub-agent / workflow cards share inside one AgentChat (Chief of Staff
// mode; plan design/2026-10-26-chief-of-staff-agents-panel.md, T7).
//
//   openAgent(ref)        opens the read-only drawer on one delegated agent
//   showWorkflow(id)      opens the right panel scrolled to that workflow
//   runs                  every workflow run of the chat, by run id, from the
//                         ONE poll AgentChat makes (useWorkflowRuns); nothing
//                         else polls a run
//
// Outside AgentChat there is no provider and `useDelegatedAgents()` is null:
// a card drawn there (a shared transcript, the design showcase's lists) is
// not clickable.

import { createContext, useContext } from 'react'
import type { WorkflowRun } from '../types.js'
import type { AgentRef } from './DelegatedAgentDrawer.js'

export type { AgentRef }

export interface DelegatedAgentsApi {
  openAgent(ref: AgentRef): void
  /** AgentChat keeps `{ toolCallId, nonce }`, so a repeat click scrolls again. */
  showWorkflow(toolCallId: string): void
  /** By run id. */
  runs: ReadonlyMap<string, WorkflowRun>
  /** The agent open in the drawer, highlighted in the Agents list. */
  selected?: AgentRef | null
  /** A run whose last read failed, by run id: the reason. */
  runErrors?: ReadonlyMap<string, string>
  retryRun?(runId: string): void
}

export const DelegatedAgentsContext = createContext<DelegatedAgentsApi | null>(null)

/** The chat's delegated-agents API; null outside AgentChat. */
export function useDelegatedAgents(): DelegatedAgentsApi | null {
  return useContext(DelegatedAgentsContext)
}
